var map = {
	"./H5_1.png": "3dae",
	"./H5_10.png": "2144",
	"./H5_11.png": "b158",
	"./H5_12.png": "229c",
	"./H5_2.png": "b3f0",
	"./H5_3.png": "9146",
	"./H5_4.png": "748a",
	"./H5_5.png": "6996",
	"./H5_6.png": "84cb",
	"./H5_7.png": "0fa1",
	"./H5_8.png": "daf5",
	"./H5_9.png": "0f05",
	"./attention.png": "a173",
	"./attentioned.png": "cd93",
	"./banner.jpg": "8842",
	"./pause.png": "b4e3",
	"./play.png": "ff9c",
	"./share.jpg": "6979"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d70c";